import { render, staticRenderFns } from "./VxScrollArea.vue?vue&type=template&id=c27ec07c&scoped=true"
import script from "./VxScrollArea.vue?vue&type=script&lang=js"
export * from "./VxScrollArea.vue?vue&type=script&lang=js"
import style0 from "./VxScrollArea.vue?vue&type=style&index=0&id=c27ec07c&prod&scoped=true&lang=css"
import style1 from "./VxScrollArea.vue?vue&type=style&index=1&id=c27ec07c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27ec07c",
  null
  
)

export default component.exports